export default {
  methods: {
    backToDailyReport()
    { console.log('query=', this.$route.query);
      let query = {
        date: this.$route.query?.date
      };

      if(this.$route.query?.index){
        query.index = this.$route.query?.index;
      }

      if (this.$route.query?.discharger_site_id) {
        query.discharger_site_id = this.$route.query.discharger_site_id;
      }
      
      if (this.$route.query?.vendor_site_id) {
        query.id = this.$route.query.vendor_site_id
        query.zz_vendor_site_4_id = this.$route.query.zz_vendor_site_4_id

        return this.$router.push({
          name: 'daily-reports-factory',
          params: {id: query.id},
          query: query
        })
      }

      return this.$router.push({
        name: 'daily-reports',
        query: query
      });
    }
  }
};